import React from 'react';
import AnimatedNumber from './AnimatedNumber';

const stats = [
  { end: 30, prefix: '+', suffix: '%', label: 'Redução de custos operacionais', icon: 'trending_down' },
  { end: 50, prefix: '+', suffix: '%', label: 'Aumento da eficiência dos processos', icon: 'speed' },
  { end: 90, prefix: '',  suffix: '%', label: 'Melhora na satisfação do cidadão', icon: 'sentiment_satisfied' },
];

const ResultadosSection = ({ animate }) => (
  <section id="resultados" className="py-24 relative overflow-hidden" style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 60%, #1d4ed8 100%)' }}>
    {/* Decorative */}
    <div className="absolute inset-0 pointer-events-none overflow-hidden">
      <div className="absolute top-0 right-0 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl" />
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-violet-500/10 rounded-full blur-3xl" />
    </div>

    <div className="relative container mx-auto px-6 md:px-12">
      <div className="text-center mb-16">
        <div className="inline-flex items-center gap-2.5 mb-5 justify-center">
          <span className="w-1 h-4" style={{ background: '#F47920' }} />
          <span className="text-xs font-bold uppercase tracking-widest" style={{ color: '#fdba74' }}>
            Resultados Reais
          </span>
        </div>
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4 tracking-tight">
          Impacto mensurável na sua gestão
        </h2>
        <p className="text-blue-200/70 max-w-xl mx-auto leading-relaxed">
          Veja o impacto real que nossa solução pode trazer para a sua gestão:
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
        {stats.map((stat, i) => (
          <div
            key={i}
            className="group bg-white/5 border border-white/10 rounded-xl p-8 text-center hover:bg-white/10 hover:border-white/20 transition-all duration-200"
          >
            <span className="material-icons text-blue-300/60 text-3xl mb-4 block">{stat.icon}</span>
            <p className="text-5xl md:text-6xl font-extrabold mb-3 tracking-tight" style={{ color: '#F47920' }}>
              <AnimatedNumber
                key={`${animate}-${i}`}
                end={stat.end}
                prefix={stat.prefix}
                suffix={stat.suffix}
              />
            </p>
            <p className="text-blue-200/70 text-sm font-medium leading-relaxed">{stat.label}</p>
          </div>
        ))}
      </div>

      {/* CTA row */}
      <div className="text-center mt-16">
        <a
          href="#planos"
          onClick={e => { e.preventDefault(); document.querySelector('#planos')?.scrollIntoView({ behavior: 'smooth' }); }}
          className="inline-flex items-center gap-2 bg-white text-blue-900 font-bold px-8 py-4 rounded-lg shadow-md hover:shadow-lg transition-all duration-200 text-sm"
        >
          Ver Planos e Preços
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
          </svg>
        </a>
      </div>
    </div>
  </section>
);

export default ResultadosSection;
